import React from 'react'
import "./About.css"
const About=()=> {
  return (
    <>
      <div className="about_main">
        <label>Developer - Vishal Raccha</label>
        <div className="infoabout">
          <p className="paraab">
          Welcome to CSS-LAB, the ultimate destination for frontend developers seeking to elevate their web design game! Our platform is a treasure trove of meticulously crafted elements designed to enhance the aesthetics and functionality of your website. Whether you're in need of a sleek navbar to improve navigation, eye-catching buttons to boost user engagement, stylish radio buttons for form inputs, or elegant cards to showcase content, CSS-LAB has you covered.
        </p>
        <br />
        <p className="paraab">Join the CSS-LAB community today and unlock a world of possibilities for your web projects. Elevate your design, save time, and impress your users with the power of CSS-LAB!</p>
        </div>
      </div>
    </>
  )
}
export default About;